module.exports = __webpack_public_path__ + "img/利润.5c8c4e8a.png";